export const API_ENDPOINTS = {
  auth: {
    login: "/api/auth/login",
    logout: "/api/auth/logout",
    profile: "/api/profile",
    password: "/api/profile/password",
  },
  orders: {
    list: "/api/listFileOrder",
    saveFromString: "/api/orderFromString",
    email: (id) => `/api/orders/${id}/email`,
  },
  offers: {
    list: "/api/listFileOffer",
    saveFromString: "/api/offerFromString",
  },
  employees: {
    list: "/api/employees",
  },
  admin: {
    login: "/api/admin/login",
    employees: "/api/admin/employees",
    blockEmployee: (id) => `/api/admin/employees/${id}/block`,
    unblockEmployee: (id) => `/api/admin/employees/${id}/unblock`,
    qrChallenge: "/api/admin/qr/challenge",
    qrStatus: "/api/admin/qr/status",
    backfillOrderInputModes: "/api/admin/orders/input-mode/backfill",
    backfillTextOrderWorkbooks: "/api/admin/orders/text-workbook/backfill",
    backfillOfferRemarksFromAnalog: "/api/admin/offers/remark-from-analog/backfill",
    wakeComputer: "/api/admin/system/wake-computer",
    llmUsageSummary: "/api/admin/llm-usage/summary",
    llmUsageRequests: "/api/admin/llm-usage/requests",
    llmUsageBalance: "/api/admin/llm-usage/balance",
  },
  reports: {
    summary: "/api/report",
  },
  ocr: {
    extractPartNumbers: "/api/ocr/extract-pn",
  },
  components: {
    search: "/api/components/search",
    rowsSearch: "/api/components/rows/search",
    filter: "/api/components/filter",
    filterByComponents: "/api/components/filter-by-components",
    offersByName: "/api/components/offers-by-name",
    recentOffers: "/api/components/recent-offers",
    componentInfo: "/api/components/component-info",
    refreshComponent: "/api/components/refresh-component",
    debugOrder: "/api/components/debug-order",
    debugOrderExcel: "/api/components/debug-order-excel",
    debugOffer: "/api/components/debug-offer",
    debugOfferExcel: "/api/components/debug-offer-excel",
  },
};
